export default {
	noEvents: "No events found",
	noEventsDescription: "There are no events to display in this timeline",
};
